import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/src/components/Docs/DocsLayout.tsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Installation`}</h1>
    <h2>{`npm`}</h2>
    <p><a parentName="p" {...{
        "href": "https://github.com/andresz1/react-tesfy"
      }}>{`react-tesfy`}</a>{` could be installed via `}<a parentName="p" {...{
        "href": "https://www.npmjs.com/"
      }}>{`npm`}</a>{` or `}<a parentName="p" {...{
        "href": "https://yarnpkg.com/"
      }}>{`yarn`}</a>{`. This is the recommended way to get the library.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm install react-tesfy --save
# or
yarn add react-tesfy
`}</code></pre>
    <h2>{`Initialization`}</h2>
    <p>{`Create an engine instance using a `}<inlineCode parentName="p">{`datafile`}</inlineCode>{` and optionally a `}<inlineCode parentName="p">{`storage`}</inlineCode>{` layer to enable sticky bucketing, a `}<inlineCode parentName="p">{`userId`}</inlineCode>{` and a set of `}<inlineCode parentName="p">{`attributes`}</inlineCode>{` and then render the provider with it.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`import { createInstance, TesfyProvider } from 'react-tesfy';

const App = () => {
  const engine = createInstance({ datafile, userId });

  return (
    <TesfyProvider engine={engine}>
      {children}
    </TesfyProvider>
  );
};
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      